import React from "react";
import {FieldProps} from "./Types/FieldProps";

export default class Field<P extends FieldProps = any, S = any> extends React.Component<P, S> {
}